import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { intervalTypesEnum } from "./intervalTypesEnum";
import s from './index.module.css';
import Button from "@UI/New/Button";

export const IntervalType = () => {

    return (
        <div className={s.tabs}>
            <CustomButton tab={intervalTypesEnum.oneTime} text='Разовый' />
            <CustomButton tab={intervalTypesEnum.regular} text='Регулярный' />
            <CustomButton tab={intervalTypesEnum.biweekly} text='Раз в 2 недели' />
            <CustomButton tab={intervalTypesEnum.customDays} text='В определенные дни' />
        </div>
    )
}

const CustomButton = ({text, tab}) => {
    const { state, setFieldInState } = useContext(ModalSettingContext);
    return(
        <Button
            onClick={() => setFieldInState({field: 'interval_type', value: tab})}
            color='primary'
            variant={tab === state.interval_type ? 'default' : 'outline'}
        >
            { text }
        </Button>
    )
}